import React from "react";
import { Quote } from "lucide-react";

export const FounderStory = () => {
  return (
    <section
      id="story"
      data-testid="founder-story"
      className="relative py-24 md:py-36 border-t border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <div className="relative aspect-[4/5] max-w-md border border-[#27272A] rounded-sm overflow-hidden">
              <img
                src="https://customer-assets-lxgj4vgw.emergentagent.net/job_gland-positioning/artifacts/47ee00d9456314d2_IMG_2427.jpeg"
                alt="AdjustaGland founder — commercial electrician using the tool in his workshop"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="max-w-md mt-5">
              <div className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA] mb-2">
                Founder · Commercial Electrician · UK
              </div>
              <div className="font-display text-2xl md:text-3xl leading-tight">
                Built on the bench.
                <br />
                Refined on site.
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <span className="label-eyebrow">06 / Built By Electricians</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter mt-4">
              A trade problem.
              <br />
              <span className="text-[#FF6B00]">A trade solution.</span>
            </h2>

            <div className="mt-8 space-y-5 text-[#D4D4D8] text-base md:text-lg leading-relaxed">
              <p>
                AdjustaGland was developed from real-world experience after
                years of identifying the same daily frustration faced by
                commercial electricians across the UK — marking SWA gland
                positions accurately, consistently and without wasted time.
              </p>
              <p>
                The founder spent over a decade on the tools, building panels
                and installing switchgear for industrial clients. Every job
                involved the same manual process. Every job introduced the same
                small errors. AdjustaGland is the answer engineered from that
                experience.
              </p>
            </div>

            <div className="mt-10 p-6 md:p-8 border-l-2 border-[#FF6B00] bg-[#141414]/60">
              <Quote className="w-6 h-6 text-[#FF6B00] mb-3" />
              <p className="font-display text-xl md:text-2xl leading-snug">
                &quot;I built AdjustaGland because every electrician I know was
                doing the same thing — and we all knew there had to be a better
                way.&quot;
              </p>
              <div className="mt-5 font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                Founder · AdjustaGland Ltd · UK
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
